import React from 'react';
import '../styles/CustomizationOptions.css';

const CustomizationOptions = () => {
  return (
    <section id="customization" className="customization-section">
      <div className="customization-container">
        
        {/* Section Header */}
        <div className="customization-header">
          <span className="customization-tagline">Personalize Your Brand</span>
          <h2 className="customization-title">
            Customization <span className="customization-highlight">Options</span>
          </h2>
          <div className="customization-underline"></div>
          <p className="customization-subtitle">
            Make your brand truly unique with our comprehensive customization options.
          </p>
        </div>

        {/* Simple Message */}
        <div className="customization-message">
          <div className="customization-message-icon">🎨</div>
          <h3>Customization Available on Request</h3>
          <p>All customization options are available on request. Contact us to discuss your specific requirements, pricing, and minimum order quantities.</p>
        </div>

        {/* CTA Section */}
        <div className="customization-cta">
          <div className="customization-cta-content">
            <h3>Ready to Create Your Unique Brand?</h3>
            <p>Get in touch with our customization experts for a free consultation</p>
            <div className="customization-cta-buttons">
              <a href="#b2b-inquiry" className="customization-cta-primary">
                Request Customization Quote
                <svg className="customization-cta-icon" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
              <a href="tel:03323240508" className="customization-cta-secondary">
                Talk to Expert
              </a>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default CustomizationOptions;